export const TOOLTIP_REGISTER = 'Tooltip/TOOLTIP_REGISTER'
export const TOOLTIP_UNREGISTER = 'Tooltip/TOOLTIP_UNREGISTER'

export const TOOLTIP_BASKET = 'basket'
export const TOOLTIP_QUICK_ORDER = 'quickOrder'
export const TOOLTIP_BASKET_SIDEPANEL = 'sidepanel'
export const TOOLTIP_ORDER_OVERVIEW = 'orderOverview'
export const TOOLTIP_PART_QUANTITY_MUTATION = 'partQuantityMutation'
